<template>
  <div class="title">
    {{title}}
  </div>
</template>
<script>
export default {
  name: 'NavTitle',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  }
}

</script>
<style scoped lang="scss">
.title {
  display: inline-block;
  position: relative;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 23.87px;
  color: rgba(18, 18, 18, 1);
  text-align: left;
  vertical-align: top;
}
.title:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 8px;
  opacity: 1;
  z-index: -1;
  background: rgba(207, 236, 255, 1);
}

</style>